export default {
  DISTRIBUTE_BALANCE_COMMAND: Symbol.for('DISTRIBUTE_BALANCE_COMMAND'),
  DISTRIBUTE_BALANCE_REPOSITORY: Symbol.for('DISTRIBUTE_BALANCE_REPOSITORY'),
};
